import { Fragment, useState } from "react";

import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";

import Check from "./checkmark.png";
import {
  useOrgPk,
  useMyOrgInfo,
} from "../../Layout/AppMain/LoginStatusContext";
import { useQuery, useMutation } from "@apollo/client";
import {
  CHECK_DISCOUNT_STATUS,
  CREATE_CHECKOUT_URL,
  CREATE_SUPPORTER_CHECKOUT_URL,
} from "../../queries";

import registerExplainImage from "../../assets/utils/images/register_explain.png";
import { useSettingOrgTab } from "../../Layout/AppMain/SettingOrgTabContext";

const PricingSupporter = () => {
  const { orgActiveTab, setOrgActiveTab } = useSettingOrgTab();
  const orgPk = useOrgPk();
  const userOrgInfo = useMyOrgInfo();
  const orgContract =
    userOrgInfo &&
    userOrgInfo.contract &&
    userOrgInfo.contract.plan &&
    userOrgInfo.contract.plan.name;

  const [cso, setCso] = useState(false);
  const [noOrgUserModal, setNoOrgUserModal] = useState(false);

  const noOrgUserModalToggle = () => setNoOrgUserModal(!noOrgUserModal);

  const { loading, error, data } = useQuery(CHECK_DISCOUNT_STATUS, {
    variables: { id: orgPk },
  });

  // Create Checkout URL
  const [createCheckoutUrl, { resultData }] = useMutation(
    CREATE_SUPPORTER_CHECKOUT_URL
  );
  const checkout = async (planId) => {
    if (!orgContract || orgContract === "Free") {
      try {
        const result = await createCheckoutUrl({
          variables: { contractId: planId },
        });
        window.open(result?.data?.supporterCheckoutSubscription?.url, "_blank");
      } catch (err) {
        alert(err);
      }
    } else {
      alert(
        `既に${orgContract}をご契約中です、契約内容を変更する場合はお問合せフォームよりご連絡ください。`
      );
    }
  };

  const discountStatus =
    data &&
    data.allOrgaccount &&
    data.allOrgaccount.edges[0] &&
    data.allOrgaccount.edges[0].node &&
    data.allOrgaccount.edges[0].node.discountProgress &&
    data.allOrgaccount.edges[0].node.discountProgress.discountAvailable;

  const discountCheckout = (planId) => {
    const url = "/#/dashboards/plofile-organization";
    let target1 = document.getElementById("csoPriceButton1");
    let target2 = document.getElementById("csoPriceButton2");

    if (discountStatus) {
      checkout(planId);
    } else {
      alert(
        "CSO料金プランの契約には、各種書類の提出が必要です。\n\n次の画面から必要書類をご提出ください。"
      );
      target1.setAttribute("href", url);
      target2.setAttribute("href", url);
      setOrgActiveTab("5");
    }
  };

  return (
    <Fragment>
      <div>
        <div className="pricePran_sec">
          <h2 className="pricePlanTitle">料金プラン</h2>
          {/* <div className="price__cso__btn">
            <Button
              onClick={() => {
                if (orgPk === "このユーザーは組織と紐づいていません") {
                  noOrgUserModalToggle();
                } else {
                  setCso(!cso);
                }
              }}
              className="ema__btn__main"
            >
              {cso ? "一般の方はこちら" : "CSOの方はこちら"}
            </Button>
          </div> */}

          <div
            className="priceItems"
            style={{
              justifyContent: "center",
              gap: "20px",
            }}
          >
            <div className="sku">
              <div className="detail">
                <h4 className="name">Freeプラン</h4>
                {cso && <div className="cso__margin"></div>}
                <div className="price">
                  <div className="value">
                    ¥ 0<span>/月</span>
                  </div>
                  <div
                    className="clarifications"
                    style={{ visibility: "hidden" }}
                  >
                    ユーザーあたりの月額
                  </div>
                </div>

                <div className="" style={{ height: "44px" }}></div>
              </div>

              <ul className="features">
                <li>
                  <img src={Check} />
                  <span>ユーザー数:1枠</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>マップ組織検索</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>組織リスト</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>組織詳細情報閲覧</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>組織事業照会</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>組織財務データ閲覧</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>マーケット推移, CSO設立推移</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>お気に入りCSO管理</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>自組織の連携方針整理機能</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>CSOコミニケーション</span>
                </li>
              </ul>
            </div>
            <div className="sku">
              <div className="detail">
                <h4 className="name" style={{ position: "relative" }}>
                  Basic 年プラン
                  {cso && (
                    <spna
                      style={{
                        fontSize: "0.8rem",
                        position: "absolute",
                        top: "-9px",
                      }}
                    >
                      {" "}
                      ※4
                    </spna>
                  )}
                </h4>
                {cso && <div className="cso__margin"></div>}
                <div className="price">
                  <div className="value">
                    ¥ 216,000<span>/年</span>
                  </div>
                  {cso && (
                    <div className="discount_price">
                      <div className="discount_value">¥ 18,000</div>
                      <span></span>
                    </div>
                  )}

                  <div className="clarifications">(¥ 18,000 円/月)</div>
                </div>

                {cso ? (
                  <a
                    id="csoPriceButton2"
                    className="ctaBtn csoPriceButton pointer"
                    onClick={() => discountCheckout("10012")}
                  >
                    使ってみる
                  </a>
                ) : (
                  <a
                    className="ctaBtn pointer"
                    onClick={() => checkout("10012")}
                  >
                    使ってみる
                  </a>
                )}
              </div>
              <ul className="features">
                <li>
                  <img src={Check} />
                  <span>ユーザー数: 3枠(*1)</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>マップ組織検索</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>組織リスト</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>組織事業照会</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>組織財務データ閲覧</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>マーケット推移, CSO設立推移</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>お気に入りCSO管理</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>自組織の連携方針整理機能</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>CSOコミニケーション</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>CSO簡単検索/ 比較分析機能</span>
                </li>
                <li>
                  <img src={Check} />
                  <span>PDFダウンロード3回(*2)</span>
                </li>
                <li>
                  <span>
                    *1)3ユーザー以上の利用ご希望の際は、別途お問合せください。
                  </span>
                </li>
                <li>
                  <span>
                    *2)月ごとに付与※使用期限が月内、組織に対して3チケット付与される
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <Modal isOpen={noOrgUserModal} toggle={noOrgUserModalToggle}>
          <ModalBody className="mt-3 ml-3 mr-3 ">
            <p className="bold" style={{ marginBottom: 30 }}>
              CSOプランを適用するには、組織登録が必要です。
              <br />
              画面右上の「組織登録ボタン」より登録してください。
            </p>

            <img
              style={{ width: "100%", margin: "auto" }}
              src={registerExplainImage}
            ></img>
          </ModalBody>
          <ModalFooter style={{ background: "#fff", borderTop: "none" }}>
            <Button
              className="mb-2"
              style={{ margin: "auto" }}
              onClick={noOrgUserModalToggle}
            >
              閉じる
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </Fragment>
  );
};

export default PricingSupporter;
